/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryQueryFilter {
    getFixupPrototypeFunction() { return InventoryQueryFilter.fixupPrototype; }

    static newInstance(model: Partial<InventoryQueryFilter>): InventoryQueryFilter {
        let obj = Object.assign(new InventoryQueryFilter(), model);
        InventoryQueryFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryQueryFilter>): InventoryQueryFilter {
        if (!model) return null;
        return InventoryQueryFilter.newInstance(<InventoryQueryFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryQueryFilter) {
        if (!obj) return;

        models.InventoryQueryFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryQueryFilter): boolean {
        Object.setPrototypeOf(obj, InventoryQueryFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Query operator tree evaluated against the resource records. Cloud accounts are named inside it through ResourceInventoryAccount rather than beside it, so one filter has one shape.
     */
    query: models.QueryOperator;

}
